import config from '@/services/config';
import settings from '@/services/settings';

export default {
  settings,
  config: Object.freeze(config),
  translations: {},
};
